import { transitionShareQuoteForm } from '../../../actions/biasharaFlexi/quote';
import { FIELD_STATUS } from '../../../reducers/status';
import { getBiasharaFlexiCoverDetailsForm } from '../../../selectors/biasharaFlexi/coverDetails';

export const shareQuoteFormRules = (store, next, action) => {
	const result = next(action);
	const shareQuoteForm = getBiasharaFlexiCoverDetailsForm(store.getState());
	const quoteFormValid = validateShareQuoteFormDetails(shareQuoteForm);
	const formAction = quoteFormValid ? transitionShareQuoteForm.formValid() : transitionShareQuoteForm.formInvalid();
	store.dispatch(formAction);

	return result;
};

const validateShareQuoteFormDetails = (formFields) => {
	return (
		formFields.shareEmail && formFields.shareEmail.status === FIELD_STATUS.VALID
	);
};
